import { Stack } from '@chronosphereio/chrono-ui';
import type { ReactNode } from 'react';

export interface QueryEditorInputContainerProps {
  children: ReactNode;
}

/**
 * Inner visual wrapper for the editor input row. Provides background color and
 * padding to distinguish the input area from surrounding sections (toolbar,
 * action panels) inside a Container.
 */
export function QueryEditorInputContainer({ children }: QueryEditorInputContainerProps) {
  return (
    <Stack bgcolor="background.default" padding={1}>
      {children}
    </Stack>
  );
}
